export default "__VITE_ASSET__B5rtL$An__"